/**
 * doc-center URL search 参数模型与解析。
 *
 * 独立成无副作用小模块：路由壳的 beforeLoad 需要同步解析 search 参数，
 * 若经由 doc-center-page / barrel 导入，会把整个页面组件树静态拖进
 * 入口 chunk（登录页连带下载编辑器、图标库等重型依赖）。
 */
export interface DocCenterSearch {
  shared?: "1";
  priPackId?: string;
  pubPackId?: string;
  fileId?: string;
  fileMode?: "edit";
  /** 被引列表打开来源文件时用于解析目标引文的不可变记录 ID */
  citationId?: string;
  page?: string;
  bbox?: string;
  blockId?: string;
  /** 沉浸式搜索：sq 存在即 overlay 打开（空串 = 首页态） */
  sq?: string;
  sSpace?: string;
  sType?: string;
  sTags?: string;
  sBind?: string;
  sSort?: string;
  sPage?: string;
  sFileId?: string;
  /** Agent 整理提案确认对话框：proposals=1 即打开（提案卡/入口深链） */
  proposals?: "1";
}

export function extractSearchParams(rawSearch: unknown): DocCenterSearch {
  if (!rawSearch || typeof rawSearch !== "object") {
    return {};
  }
  const result: DocCenterSearch = {};
  for (const [key, value] of Object.entries(rawSearch)) {
    if (key === "shared" && value === "1") result.shared = value;
    if (key === "fileId" && typeof value === "string") result.fileId = value;
    else if (key === "fileMode" && value === "edit") result.fileMode = value;
    else if (key === "citationId" && typeof value === "string") result.citationId = value;
    // TanStack Router 对 search 值做 JSON.parse，纯数字串会变 number（同 sPage）
    else if (key === "page" && (typeof value === "string" || typeof value === "number"))
      result.page = String(value);
    else if (key === "bbox" && typeof value === "string") result.bbox = value;
    else if (key === "blockId" && typeof value === "string") result.blockId = value;
    else if (key === "priPackId" && typeof value === "string")
      result.priPackId = value;
    else if (key === "pubPackId" && typeof value === "string")
      result.pubPackId = value;
    else if (key === "sq" && typeof value === "string") result.sq = value;
    else if (key === "sSpace" && typeof value === "string") result.sSpace = value;
    else if (key === "sType" && typeof value === "string") result.sType = value;
    else if (key === "sTags" && typeof value === "string") result.sTags = value;
    else if (key === "sBind" && typeof value === "string") result.sBind = value;
    else if (key === "sSort" && typeof value === "string") result.sSort = value;
    else if (key === "sPage" && (typeof value === "string" || typeof value === "number"))
      // TanStack Router 默认对 search 值做 JSON.parse，纯数字串会变成 number
      result.sPage = String(value);
    else if (key === "sFileId" && typeof value === "string") result.sFileId = value;
    else if (key === "proposals" && value === "1") result.proposals = value;
  }
  return result;
}
